import { render } from "./MattersUp.vue?vue&type=template&id=4cbf40d9&scoped=true"
import script from "./MattersUp.vue?vue&type=script&lang=js"
export * from "./MattersUp.vue?vue&type=script&lang=js"

import "./MattersUp.vue?vue&type=style&index=0&id=4cbf40d9&scoped=true&lang=css"

import exportComponent from "D:\\work\\zqclj\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cbf40d9"]])

export default __exports__